/** Stable machine-readable codes — keep in sync with backend `_shared/errors.ts`. */
export const ErrorCode = {
  INTERNAL: "internal_error",
  VALIDATION: "validation",
  CONFLICT: "conflict",
  UNAUTHORIZED: "unauthorized",
  FORBIDDEN: "forbidden",
  NOT_FOUND: "not_found",
  PLAN_LIMIT: "plan_limit_exceeded",
  UPSTREAM_GITHUB: "upstream_github",
  UPSTREAM_STRIPE: "upstream_stripe",
  UPSTREAM_ANTHROPIC: "upstream_anthropic",
  UPSTREAM: "upstream_error",
} as const

export type ErrorCodeValue = (typeof ErrorCode)[keyof typeof ErrorCode]

export const UserMessage = {
  GENERIC: "Something went wrong. Please try again.",
  LOAD_FAILED: "Something went wrong loading this.",
  UNAUTHORIZED: "You need to sign in to continue.",
  FORBIDDEN: "You do not have permission to do that.",
  NOT_FOUND: "The requested item could not be found.",
  NETWORK: "Network error. Check your connection and try again.",
  AUTH_INVALID: "Invalid email or password.",
  AUTH_GENERIC: "Sign-in failed. Please try again.",
} as const

/** Domain errors that are expected user flows — do not alert on these. */
export const NON_REPORTABLE_CODES = new Set<string>([
  ErrorCode.PLAN_LIMIT,
  ErrorCode.VALIDATION,
  ErrorCode.CONFLICT,
  ErrorCode.UNAUTHORIZED,
  ErrorCode.FORBIDDEN,
  ErrorCode.NOT_FOUND,
])
